import { Button } from '@/components/ui/button';
import { Loader2, Plus } from 'lucide-react';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { namespace } from '@common-config/constants';

interface DeployNewEngineButtonProps {
  onClick: () => void;
  disabled?: boolean;
  isLoading?: boolean;
  className?: string;
}

export const DeployNewEngineButton: React.FC<DeployNewEngineButtonProps> = ({
  onClick,
  disabled = false,
  isLoading = false,
  className = ''
}) => {
  const { t } = useTranslation(namespace);

  const handleMouseEnter = (e: React.MouseEvent<HTMLButtonElement>) => {
    if (!isLoading && !disabled) {
      e.currentTarget.style.background = 'var(--remote-connect-hover-bg)';
      e.currentTarget.style.boxShadow = '0 8px 25px rgba(var(--remote-connect-shadow-rgb), 0.4)';
    }
  };

  const handleMouseLeave = (e: React.MouseEvent<HTMLButtonElement>) => {
    if (!isLoading && !disabled) {
      e.currentTarget.style.background = 'var(--remote-connect-bg)';
      e.currentTarget.style.boxShadow = '0 4px 15px rgba(var(--remote-connect-shadow-rgb), 0.3)';
    }
  };

  const handleMouseDown = (e: React.MouseEvent<HTMLButtonElement>) => {
    if (!isLoading && !disabled) {
      e.currentTarget.style.background = 'var(--remote-connect-active-bg)';
      e.currentTarget.style.boxShadow = '0 2px 8px rgba(var(--remote-connect-shadow-rgb), 0.5)';
    }
  };

  const handleMouseUp = (e: React.MouseEvent<HTMLButtonElement>) => {
    if (!isLoading && !disabled) {
      e.currentTarget.style.background = 'var(--remote-connect-hover-bg)';
      e.currentTarget.style.boxShadow = '0 8px 25px rgba(var(--remote-connect-shadow-rgb), 0.4)';
    }
  };

  return (
    <Button
      onClick={onClick}
      disabled={disabled || isLoading}
      className={`relative overflow-hidden transition-all duration-300 ease-out hover:shadow-xl active:scale-[0.98] focus:outline-none focus:ring-4 focus:ring-blue-300/50 disabled:hover:shadow-none group ${className}`}
      style={{
        background: 'var(--remote-connect-bg)',
        color: '#ffffff',
        boxShadow: '0 4px 15px rgba(var(--remote-connect-shadow-rgb), 0.3)',
      }}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      onMouseDown={handleMouseDown}
      onMouseUp={handleMouseUp}
    >
      {isLoading && <Loader2 className="h-4 w-4 mr-2 animate-spin" />}
      <Plus className="h-4 w-4 mr-2" />
      {t('enginesManagement.deployNewEngine')}
    </Button>
  );
};
